export default "__VITE_ASSET__Qb3upYrA__"